/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tab, Tabs } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { ProductModel } from "../../Utils/Models";
import { ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { Vocabulary } from "../../Utils/Vocabulary";
import Product from "./Product";
import Price from "./Price";
import VariantsAndAttributes from "./AttributesAndVariants/VariantsAndAttributes";
import { urlEnum } from "../../Utils/UrlEnum";
import { getData } from "../../Services/getData";
import ProductStock from "./ProductStock";
import useCustomMemo from "../GenericComponents/useCustomMemo";
import AlertsForProducts from "./AlertsForProducts";

type ProductMainPageProps = {
  editProduct: ProductModel | null;
  open: boolean;
  addOrUpdateProduct: (product: ProductModel) => void;
  onClose: () => void;
};
export default function ProductMainPage(props: ProductMainPageProps) {
  const { editProduct, open, addOrUpdateProduct, onClose } = props;
  const cache = useCustomMemo();
  const inventoriesFromCache = cache.inventories || [];
  const ref: any = useRef();
  const [product, setProduct] = useState<ProductModel>(new ProductModel());
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const [value, setValue] = useState(0);
  const [arraysOfString, setArraysOfString] = useState<any>({
    tags: [],
  });

  /**
   *
   */
  useEffect(() => {
    if (editProduct) {
      setProduct(editProduct);
    } else {
      const newProduct = new ProductModel();
      setProduct(newProduct);
    }
    getArraysOfString();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editProduct]);

  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }
  /**
   *
   * @param event
   * @param newValue
   */
  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  }

  /**
   *
   * @param value
   */
  function handleChangeProduct(value: ProductModel) {
    setProduct(value);
  }

  /**
   *
   */
  function getArraysOfString() {
    const url = `${urlEnum.products}/arraysOfString`;
    getData(url).then((res: any) => {
      if (res.data.status === 200) setArraysOfString(res.data.result);
    });
  }

  /**
   *
   * @param arraysOfString
   */
  function handleChangeArraysOfString(arraysOfString: any) {
    setArraysOfString(arraysOfString);
  }
  /**
   *
   */
  function showInformation() {
    switch (value) {
      case 0:
        return (
          <Product
            product={product}
            arraysOfString={arraysOfString}
            handleChangeProduct={handleChangeProduct}
            handleChangeArraysOfString={handleChangeArraysOfString}
          />
        );
      case 1:
        return (
          <VariantsAndAttributes
            product={product}
            handleChangeProduct={handleChangeProduct}
          />
        );
      case 2:
        return (
          <ProductStock
            allInventoriesForAutocomplete={inventoriesFromCache}
            inventories={product.inventories || []}
            handleChangeInventories={(inventories) => {
              handleChangeProduct({ ...product, inventories: inventories });
            }}
          />
        );
      case 3:
        return (
          <Price product={product} handleChangeProduct={handleChangeProduct} />
        );
      case 4:
        return <AlertsForProducts product={product} />;
      default:
        break;
    }
  }

  return (
    <ValidatorForm ref={ref} onSubmit={() => addOrUpdateProduct(product)}>
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.product}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
        submitButtonDisabled={
          product.options.find(
            (option) =>
              option.name === "" &&
              option.values.length === 1 &&
              option.values[0] === ""
          )
            ? true
            : false
        }
      >
        <Tabs
          value={value}
          onChange={handleChangeValue}
          textColor="inherit"
          sx={{ width: "100%" }}
        >
          <Tab label={Vocabulary.product} />
          <Tab label={Vocabulary.variantsAndAttributes} />
          <Tab label={Vocabulary.stock} />
          <Tab label={Vocabulary.price} />
          {product._id ? <Tab label={Vocabulary.alerts} /> : null}
        </Tabs>
        {showInformation()}
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
